import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  employeeObjectivesLength: 0,
  employeeObjectives: [],
  employeeObjective: {},
  employeeObjectiveError: "",
  formError: "",
  objectivesModified: false,
};

export default function EmployeeObjectiveReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADING_EMPLOYEE_OBJECTIVE:
      return { ...state, loading: action.payload };
    case actions.LOADING_EMPLOYEE_OBJECTIVE_BY_ID:
      return { ...state, loadingById: action.payload };
    case actions.SAVE_LOADING_EMPLOYEE_OBJECTIVE:
      return { ...state, saveLoading: action.payload };
    case actions.GET_EMPLOYEE_OBJECTIVE:
      return {
        ...state,
        employeeObjectives: action.payload.employeeObjectives,
        employeeObjectivesLength: action.payload.employeeObjectivesLength,
      };
    case actions.GET_EMPLOYEE_OBJECTIVE_BY_ID:
      return {
        ...state, employeeObjective: action.payload
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.EMPLOYEE_OBJECTIVE_FAIL:
      return { ...state, employeeObjectiveError: action.payload };
    case actions.SET_OBJECTIVES_MODIFIED:
      return { ...state, objectivesModified: action.payload };
    default:
      return state;
  }
}
